import { ApiError } from '../api/client';

export function authenticationErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (error instanceof ApiError) {
    const detail = error.details?.[0];
    return detail?.reason ?? error.message;
  }
  if (error instanceof Error && error.message.length > 0) return error.message;
  return fallback;
}

export function hasHttpStatus(error: unknown, status: number): boolean {
  return error instanceof ApiError && error.status === status;
}

export function isTransientAuthenticationError(error: unknown): boolean {
  return (
    error instanceof ApiError &&
    (error.status === 0 ||
      error.status === 408 ||
      error.status === 429 ||
      error.status >= 500)
  );
}
